export const VALID_BUTTON_STYLES = ['default', 'destroy', 'premium', 'red-default', 'crypto', 'caution']
export const VALID_BUTTON_TEXT_STYLES = ['default', 'large']
